import {FormikSelect} from '@flexinet/ui-components';
import {FieldProps} from 'formik';
import {SelectProps} from '@mantine/core';

const reportingCategoryOptions = [
    {value: 'charge', label: 'Charge'},
    {value: 'refund', label: 'Refund'},
    {value: 'dispute', label: 'Dispute'},
    {value: 'dispute_reversal', label: 'Dispute Reversal'},
    {value: 'fee', label: 'Fee'},
    {value: 'partial_capture_reversal', label: 'Partial Capture Reversal'},
    {value: 'payout_reversal', label: 'Payout Reversal'},
    {value: 'transfer', label: 'Transfer'},
    {value: 'transfer_reversal', label: 'Transfer Reversal'},
    {value: 'platform_earning', label: 'Platform Earning'},
    {value: 'platform_earning_refund', label: 'Platform Earning Refund'},
    {value: 'connect_reserved_funds', label: 'Connect Reserved Funds'},
    {value: 'risk_reserved_funds', label: 'Risk Reserved Funds'},
];

export const ReportingCategoryDropdown = (props: FieldProps & SelectProps) => {
    return <FormikSelect {...props} data={reportingCategoryOptions} clearable/>;
};
